import type { ReservationSlotSettings } from '../../domain/reservationSlots';
import type { ReservationSlotSettingsRepository } from './ports/ReservationSlotSettingsRepository';

/**
 * 解放枠の基本設定を取得するUseCase
 *
 * @param {ReservationSlotSettingsRepository} repository - Repository実装（DI）
 * @returns {Promise<ReservationSlotSettings>} 基本設定
 */
export async function getSettings(
  repository: ReservationSlotSettingsRepository
): Promise<ReservationSlotSettings> {
  return repository.get();
}
